import { createAnatomy as t } from "../../anatomy/dist/index.mjs";
import { createScope as r } from "../../dom-query/dist/index.mjs";
import { createProps as d } from "../../types/dist/index.mjs";
var g = t("dialog").parts(
  "trigger",
  "backdrop",
  "positioner",
  "content",
  "title",
  "description",
  "closeTrigger"
);
g.build();
var i = r({
  getPositionerId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.positioner) ?? `dialog:${e.id}:positioner`;
  },
  getBackdropId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.backdrop) ?? `dialog:${e.id}:backdrop`;
  },
  getContentId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.content) ?? `dialog:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.trigger) ?? `dialog:${e.id}:trigger`;
  },
  getTitleId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.title) ?? `dialog:${e.id}:title`;
  },
  getDescriptionId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.description) ?? `dialog:${e.id}:description`;
  },
  getCloseTriggerId: (e) => {
    var o;
    return ((o = e.ids) == null ? void 0 : o.closeTrigger) ?? `dialog:${e.id}:close`;
  },
  getContentEl: (e) => i.getById(e, i.getContentId(e)),
  getPositionerEl: (e) => i.getById(e, i.getPositionerId(e)),
  getBackdropEl: (e) => i.getById(e, i.getBackdropId(e)),
  getTriggerEl: (e) => i.getById(e, i.getTriggerId(e)),
  getTitleEl: (e) => i.getById(e, i.getTitleId(e)),
  getDescriptionEl: (e) => i.getById(e, i.getDescriptionId(e)),
  getCloseTriggerEl: (e) => i.getById(e, i.getCloseTriggerId(e))
});
d()([
  "aria-label",
  "closeOnEscape",
  "closeOnInteractOutside",
  "dir",
  "finalFocusEl",
  "getRootNode",
  "getRootNode",
  "id",
  "id",
  "ids",
  "initialFocusEl",
  "modal",
  "onEscapeKeyDown",
  "onFocusOutside",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "open.controlled",
  "open",
  "persistentElements",
  "preventScroll",
  "restoreFocus",
  "role",
  "trapFocus"
]);
export {
  g as anatomy
};
